import { EdgerRollPage } from "./EdgerRollPage";

const EdgerRoll = () => {
	return <EdgerRollPage />;
};
export default EdgerRoll;
